module.exports = __webpack_public_path__ + "img/1.7f08c1a6.svg";